import { generateSearchParams } from '@/utils/generateSearchParams';
import { request } from '@/utils/request';
import { ResponseBasis, ResponseWithSeo } from '@/api/api.types';
import { NewsItem, NewsListOptions } from '@/api/news/news.types';

export async function getNewsList(options: NewsListOptions) {
  const searchParams = generateSearchParams(options);
  return request<ResponseBasis<NewsItem>>(`/news-post/?${searchParams.toString()}`);
}

export async function getCurrentNews({ id }: { id: number }) {
  return request<NewsItem & ResponseWithSeo>(`/news-post/${id}/`);
}

export async function getCurrentNewsBySlug({ slug }: { slug: string }) {
  return request<NewsItem & ResponseWithSeo>(`/news-post/slug/${slug}/`);
}
